import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export const PEOPLE_KEYWORD_SUGGESTION_SUB_ENTITY_TYPES: readonly string[] = [
    'PeopleKeywordAsText',
    'History',
    'EmailKPE',
];

export interface PeopleKeywordSuggestionRequestOptions {
    isEnabled: boolean;
    subEntityTypes?: readonly string[];
}

export default function getPeopleKeywordSuggestionRequestOptions(
    isScenarioEligible: boolean = true
): PeopleKeywordSuggestionRequestOptions {
    const isEnabled =
        isScenarioEligible && isGlobalFeatureEnabled('sea-peopleKeywordAsTextSuggestion');

    return {
        isEnabled,
        subEntityTypes: isEnabled ? PEOPLE_KEYWORD_SUGGESTION_SUB_ENTITY_TYPES : undefined,
    };
}
